import React from 'react';
import { FormControlLabel, Radio, TextField } from '@material-ui/core';
import { $contains, $eq, $sw, $ew } from '../operators';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { FilterForm, useFilterFormActions } from './filter-form';
import { mergeOverride } from './override-operator';
import { useMemo } from 'react';

export const StringFilters = props => {
  return <FilterForm {...props} radioFilters={StringFilterFormItems} />;
};

function StringFilterFormItems({ setRadioFilter, radioValue, column, ...props }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );
  const actualTitle = useMemo(() => column.render('Header'), [column.Header]);
  return (
    <>
      {[$contains, $eq, $sw, $ew].map(mergeOverride(column.overrideOperator)).map(e => (
        <React.Fragment key={e.key}>
          <FormControlLabel
            value={e.key}
            control={<Radio />}
            label={
              <TextField
                onClick={handleInputClick}
                inputRef={form.register}
                name={e.key}
                disabled={getRadioValue() !== e.key}
                variant="outlined"
                size="small"
                label={e.label}
              />
            }
          />
          <br />
        </React.Fragment>
      ))}
      {props.addAvailableFilter && (
        <>
          <FormControlLabel
            value="false"
            control={<Radio />}
            label="Has a value."
            name="$empty"
            inputRef={form.register}
          />
          <FormControlLabel
            value="true"
            control={<Radio />}
            label="Does not have a value."
            name="$empty"
            inputRef={form.register}
          />
        </>
      )}
      {props.addNonLinkedEntityFilter && (
        <>
          <FormControlLabel
            value="yes"
            control={<Radio />}
            label={`Deals where ${actualTitle} is linked`}
            name="$linked"
            inputRef={form.register}
          />
          <FormControlLabel
            value="no"
            control={<Radio />}
            label={`Deals where ${actualTitle} is not linked`}
            name="$linked"
            inputRef={form.register}
          />
        </>
      )}
    </>
  );
}
